import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../_partials/hooks/useDeviationAttributes';
import ShareButton from '../../buttons/ShareButton';
import CommentButton from '../../buttons/CommentButton';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import CommissionStatusButton from '../../buttons/CommissionStatusButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import ActionBarButton from '../../_partials/ActionBarButton';
import PointsIcon from '../../../Icons/Points';
import { IconSize } from '../../../Icons/IconWrap';
import { useFlag } from '../../../redux/flags/hooks';
import s from './CommissionActionBar.scss';
var CommissionActionBar = function (_a) {
    var isOwner = _a.isOwner, commission = _a.deviation.commission, deviation = _a.deviation;
    var t = useTranslation().t;
    var _b = useDeviationAttributes(deviation, isOwner), isCommentable = _b.isCommentable, isShareable = _b.isShareable, isEditable = _b.isEditable, isDeletable = _b.isDeletable;
    var moneyValueEnabled = useFlag('money_value_commissions');
    if (!commission) {
        return null;
    }
    return (React.createElement(ActionBarStrip, null,
        React.createElement(CentralColumn, { className: s['bar-elements-wrapper'] },
            React.createElement("div", { className: s['left-side'] },
                isCommentable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner }))),
                isShareable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(ShareButton, { deviation: deviation })))),
            React.createElement("div", { className: s['right-side'] },
                (isOwner || commission.isActive) && (React.createElement("span", { className: s['icon'] },
                    React.createElement(ActionBarButton, { className: s['price'], contentClassName: s['button-content'] }, moneyValueEnabled ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: s['points-value'] },
                            React.createElement(PointsIcon, { className: s['points-icon'], size: IconSize.SMALL }),
                            commission.pointsCost),
                        React.createElement("div", { className: s['dollars-cost'] }, "$" + commission.dollarsCost))) : (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: s['points-value'] }, commission.pointsCost),
                        React.createElement("div", { className: s['points-label'] }, t('common.points', { count: commission.pointsCost })),
                        ' '))))),
                !isOwner && (React.createElement("span", { className: s['icon'] },
                    React.createElement(OrderCommissionButton, { deviation: deviation, isOpen: commission.isActive }))),
                isEditable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(CommissionStatusButton, { deviation: deviation }))),
                isDeletable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(DeleteButton, { deviation: deviation }))),
                isEditable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(EditButton, { deviation: deviation })))))));
};
CommissionActionBar.displayName = 'CommissionActionBar';
export default CommissionActionBar;
//# sourceMappingURL=CommissionActionBar.js.map